import { Tab, useTheme } from '@mui/material'
import TabIcon from './TabIcon'
import { TabLabel } from './TabLabel'

const JotformTab = ({ seoTier }: { seoTier: number }) => {
  const theme = useTheme()
  const jotformUrl =
    seoTier && seoTier > 0 && seoTier === 1
      ? 'https://form.jotform.com/230364889037161'
      : 'https://form.jotform.com/222924739862164'
  const jotformLabel = seoTier && seoTier > 0 && seoTier === 1 ? 'Tier 1 Form' : 'Tier 2+ Form'
  return (
    <Tab
      className="tab-routing-custom"
      icon={<TabIcon title={jotformLabel} />}
      label={<TabLabel label={jotformLabel} />}
      disableRipple
      sx={{
        '& .MuiTab-iconWrapper': { m: 0 }, // center icon perfectly
        '--tab-routing-icon-color': theme.palette.text.highlight,
      }}
      onClick={() => window.open(jotformUrl, '_blank', 'noopener,noreferrer')}
    />
  )
}

export default JotformTab
